import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import img1 from '../../../assets/images/modalimg.png'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import amazing from '../../../assets/images/icons/amazing.png'
import good from '../../../assets/images/icons/good.png'
import okay from '../../../assets/images/icons/okay.png'
import notwell from '../../../assets/images/icons/notwell.png'
import terrible from '../../../assets/images/icons/terrible.png'

import axios from "axios";

const MarkNowModal = ({ show, handleClose }) => {

    const[feel,setfeel]=useState(3);

    const[sleep,setSleep]=useState(2);

    const[active,setActive]=useState("3")

    const configData = useSelector((state) => state.configSlice);

    const userData = useSelector((state) => state.userSlice);

    var uuid = userData?.user?.uuid;

    const navigate = useNavigate();

   const handleMood=async(req,res)=>{
 
    const payload = {
        feel,
        sleep
    }
  
    const data= await axios.post(`${configData?.config?.apiBaseUrl}/api/postmood/${uuid}`,payload, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      })

    handleClose()

    navigate(0)

   }



    return (
        <>
            <Modal size='xl' show={show} >
                <Modal.Body>
                    <div className="row align-items-center justify-content-between">
                        <div className="col-md-4">
                            <img src={img1} className='img-fluid' alt="" />
                        </div>
                        <div className="col-md-7">
                            <h6 style={{ fontWeight: '800' }}>Let's Check in</h6>
                            <p>Scientists have demonstrated that mood and sleep can affect cognitive performance. Record these data to track your own trends.</p>
                            <h6 className='py-3'>How do you feel today</h6>
                            <ul className='d-flex moodcheck'>
                                <li className={feel==5 ? 'active' : ""}>
                                    <div onClick={()=>setfeel(5)}>
                                        <img src={amazing} alt="" />
                                        <p>Amazing</p>
                                    </div>
                                </li>
                                <li className={feel==4 ? 'active' : ""}>
                                    <div onClick={()=>setfeel(4)}>
                                        <img src={good} alt="" />
                                        <p>Good</p>
                                    </div>
                                </li>
                                <li className={feel==3 ? 'active' : ""}>
                                    <div onClick={()=>setfeel(3)}>
                                        <img src={okay} alt="" />
                                        <p>Okay</p>
                                    </div>
                                </li>
                                <li className={feel==2 ? 'active' : ""}>
                                    <div onClick={()=>setfeel(2)}>
                                        <img src={notwell} alt="" />
                                        <p>Not Well</p>
                                    </div>
                                </li>
                                <li className={feel==1 ? 'active' : ""}>
                                    <div onClick={()=>setfeel(1)}>
                                        <img src={terrible} alt="" />
                                        <p>Terrible</p>
                                    </div>
                                </li>
                            </ul>

                            <h6 className='pt-4 pb-3'>How many hours did you sleep last night ?</h6>

                            <ul className='d-flex moodcheck'>
                                <li className={active=="1" ? 'active' : ""}>
                                    <div onClick={()=>{setSleep(0);setActive("1")}}>
                                        <p>0-3h</p>
                                    </div>
                                </li>
                                <li className={active=="2" ? 'active' : ""}>
                                    <div onClick={()=>{setSleep(0);setActive("2")}}>
                                        <p>3-6h</p>
                                    </div>
                                </li>
                                <li className={active=="3" ? 'active' : ""}>
                                    <div onClick={()=>{setSleep(1);setActive("3")}}>
                                        <p>6-9h</p>
                                    </div>
                                </li>
                                <li className={active=="4" ? 'active' : ""}>
                                    <div onClick={()=>{setSleep(2);setActive("4")}}>
                                        <p>9-12h</p>
                                    </div>
                                </li>
                                <li className={active=="5" ? 'active' : ""}>
                                    <div onClick={()=>{setSleep(2);setActive("5")}}>
                                        <p>12h+</p>
                                    </div>
                                </li>
                            </ul>

                            <button className='btn btn-outline-danger px-4 mt-5' onClick={handleMood}>Submit</button>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default MarkNowModal
